import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableEpocusReviewFragment = { readonly __typename?: 'SyncableEpocusReview', readonly id: string, readonly examId: string, readonly agree: boolean, readonly qualityScore: number, readonly tags: ReadonlyArray<string>, readonly comment?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncEpocusReviewPullQueryVariables = Types.Exact<{
  input: Types.PullEpocusReviewInput;
}>;


export type SyncEpocusReviewPullQuery = { readonly __typename?: 'Query', readonly pullEpocusReview: { readonly __typename?: 'PullEpocusReviewResult', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusReview', readonly id: string, readonly examId: string, readonly agree: boolean, readonly qualityScore: number, readonly tags: ReadonlyArray<string>, readonly comment?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export type SyncEpocusReviewPushMutationVariables = Types.Exact<{
  input: Types.PushEpocusReviewInput;
}>;


export type SyncEpocusReviewPushMutation = { readonly __typename?: 'Mutation', readonly pushEpocusReview: { readonly __typename?: 'PushEpocusReviewResult', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusReview', readonly id: string, readonly examId: string, readonly agree: boolean, readonly qualityScore: number, readonly tags: ReadonlyArray<string>, readonly comment?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly updatedAt: string, readonly createdByUserId: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableEpocusReviewFragmentDoc = gql`
    fragment WholeSyncableEpocusReview on SyncableEpocusReview {
  id
  examId
  agree
  qualityScore
  tags
  comment
  meta {
    createdAt
    updatedAt
    createdByUserId
    updatedByUserId
    deleted
  }
}
    `;
export const SyncEpocusReviewPullDocument = gql`
    query SyncEpocusReviewPull($input: PullEpocusReviewInput!) {
  pullEpocusReview(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableEpocusReview
    }
  }
}
    ${WholeSyncableEpocusReviewFragmentDoc}`;

/**
 * __useSyncEpocusReviewPullQuery__
 *
 * To run a query within a React component, call `useSyncEpocusReviewPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusReviewPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncEpocusReviewPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusReviewPullQuery(baseOptions: Apollo.QueryHookOptions<SyncEpocusReviewPullQuery, SyncEpocusReviewPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncEpocusReviewPullQuery, SyncEpocusReviewPullQueryVariables>(SyncEpocusReviewPullDocument, options);
      }
export function useSyncEpocusReviewPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncEpocusReviewPullQuery, SyncEpocusReviewPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncEpocusReviewPullQuery, SyncEpocusReviewPullQueryVariables>(SyncEpocusReviewPullDocument, options);
        }
export type SyncEpocusReviewPullQueryHookResult = ReturnType<typeof useSyncEpocusReviewPullQuery>;
export type SyncEpocusReviewPullLazyQueryHookResult = ReturnType<typeof useSyncEpocusReviewPullLazyQuery>;
export type SyncEpocusReviewPullQueryResult = Apollo.QueryResult<SyncEpocusReviewPullQuery, SyncEpocusReviewPullQueryVariables>;
export const SyncEpocusReviewPushDocument = gql`
    mutation SyncEpocusReviewPush($input: PushEpocusReviewInput!) {
  pushEpocusReview(input: $input) {
    rows {
      ...WholeSyncableEpocusReview
    }
  }
}
    ${WholeSyncableEpocusReviewFragmentDoc}`;
export type SyncEpocusReviewPushMutationFn = Apollo.MutationFunction<SyncEpocusReviewPushMutation, SyncEpocusReviewPushMutationVariables>;

/**
 * __useSyncEpocusReviewPushMutation__
 *
 * To run a mutation, you first call `useSyncEpocusReviewPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEpocusReviewPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEpocusReviewPushMutation, { data, loading, error }] = useSyncEpocusReviewPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEpocusReviewPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncEpocusReviewPushMutation, SyncEpocusReviewPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEpocusReviewPushMutation, SyncEpocusReviewPushMutationVariables>(SyncEpocusReviewPushDocument, options);
      }
export type SyncEpocusReviewPushMutationHookResult = ReturnType<typeof useSyncEpocusReviewPushMutation>;
export type SyncEpocusReviewPushMutationResult = Apollo.MutationResult<SyncEpocusReviewPushMutation>;
export type SyncEpocusReviewPushMutationOptions = Apollo.BaseMutationOptions<SyncEpocusReviewPushMutation, SyncEpocusReviewPushMutationVariables>;